<template>
  <section v-if="rankedProfessions && rankedProfessions.length">
    <JoszakiHeading :level="2">
      {{ $t("personProfile.myProfessions") }}
    </JoszakiHeading>
    <template v-for="prof in rankedProfessions">
      <JoszakiPill
        :key="prof.id"
        type="info"
        component="NuxtLink"
        inverted
        :to="
          localePath({
            name: 'professionPage',
            params: { profession: prof.seoName },
          })
        "
        class="inline-flex mr-2"
      >
        <IconComponent icon="briefcase" />
        {{ prof.name }}
        <small class="text-xs flex flex-row items-center gap-2">
          <IconComponent icon="check" class="text-success-darker" />
          <span>
            {{ prof?.winCount ?? 0 }}
            {{ $t("personProfile.professionWinCount") }}
          </span>
        </small>
      </JoszakiPill>
    </template>
  </section>
</template>

<script>
import { mapState } from "pinia";
import { useProfessionalStore } from "~/stores/professional";

export default {
  computed: {
    ...mapState(useProfessionalStore, {
      rankedProfessions: "rankedProfessions",
    }),
  },
};
</script>
